<template>
    <div>
        <el-dialog
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="60%"
            :center="true"
            top="3vh"
            :close-on-click-modal="false"
            :before-close="() => closeDialog('CurrencyEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <template #title>
                <span style="font-weight: bold;">{{dialogFormTitle}}</span>
                <el-tag v-if="currency.state===0" type="info" size="mini">待提交</el-tag>
                <el-tag v-if="currency.state===1" size="mini">审批中</el-tag>
                <el-tag v-if="currency.state===2" type="success" size="mini">已通过</el-tag>
                <el-tag v-if="currency.state===3" type="danger" size="mini">已驳回</el-tag>
                <el-button
                    v-if="(currency.state>0) && ($_has(print_auth))"
                    plain
                    circle
                    icon="el-icon-printer"
                    @click="clk_print()"
                    ></el-button
                >
            </template>
            <div>
                <el-form
                    :model="currency"
                    :rules="rules"
                    ref="CurrencyEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <fieldset class="fieldsetc">
                            <legend class="legendc">基础信息</legend>
                            <el-form-item label="申请部门" prop="department_id">
                                <el-cascader
                                    v-model="currency.department_id"
                                    :options="enterprise_department"
                                    :props="{ expandTrigger: 'hover' }"
                                    clearable
                                    style="width: 100%"
                                >
                                </el-cascader>
                            </el-form-item>
                            <el-row :gutter="10">
                                <el-col :span="12">
                                    <el-form-item  label="申请人" prop="staff_id">
                                        <el-select
                                            v-model="currency.staff_id"
                                            filterable
                                            clearable
                                            placeholder="选择申请人"
                                            class="staff_idc"
                                        >
                                            <el-option
                                                v-for="item in all_staff"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item  label="申请类型" prop="category">
                                        <el-select
                                            v-model="currency.category"
                                            filterable
                                            clearable
                                            placeholder="选择申请类型"
                                            class="categoryc"
                                        >
                                            <el-option
                                                v-for="item in all_currency_category"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </fieldset>
                        <fieldset class="fieldsetc">
                            <legend class="legendc">申请信息</legend>
                            <el-form-item label="申请标题" prop="title">
                                <el-input v-model="currency.title" clearable ></el-input>
                            </el-form-item>
                            <el-form-item label="申请原因" prop="cause">
                                <el-input type="textarea" :rows="3" v-model="currency.cause"></el-input>
                            </el-form-item>
                            <el-form-item label="其它说明" prop="content">
                                <el-input type="textarea" :rows="5" v-model="currency.content"></el-input>
                            </el-form-item>
                        </fieldset>
                        <common-upload-component
                            ref="upload"
                            :ffileList="currency.other"
                            upload_url="currency/upload"
                        ></common-upload-component>
                    </div>
                    <div v-else>
                        <fieldset class="fieldsetc">
                            <legend class="legendc">基础信息</legend>
                            <el-descriptions
                                class="margin-top"
                                :column="2"
                                :labelStyle="{'width':'120px','text-align':'center'}"
                                :contentStyle="{'text-align': 'center'}"
                                border
                            >
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请部门</span>
                                    </template>
                                    <span>{{currency.enterprise_name ? currency.enterprise_name + '/' + currency.department_name : ''}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请人</span>
                                    </template>
                                    <span>{{currency.staff_name}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请类型</span>
                                    </template>
                                    <span>{{currency.category_name}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请日期</span>
                                    </template>
                                    <span>{{currency.apply_date}}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                        </fieldset>
                        <fieldset class="fieldsetc">
                            <legend class="legendc">申请信息</legend>
                            <el-descriptions
                                class="margin-top"
                                :column="1"
                                :labelStyle="{'width':'120px','text-align':'center'}"
                                :contentStyle="{'text-align': 'center'}"
                                border
                            >
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请标题</span>
                                    </template>
                                    <span>{{currency.title}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item :contentStyle="{'text-align':'left','white-space':'pre-line'}">
                                    <template slot="label">
                                        <span>申请原因</span>
                                    </template>
                                    <span>{{currency.cause}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item :contentStyle="{'text-align':'left','white-space':'pre-line'}">
                                    <template slot="label">
                                        <span>其它说明</span>
                                    </template>
                                    <span>{{currency.content}}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                        </fieldset>
                        <common-upload-component
                            v-show="currency.other.length"
                            ref="upload"
                            :ffileList="currency.other"
                            upload_url="currency/upload"
                            :disabled="true"
                        ></common-upload-component>
                        <common-upload-component
                            v-show="AddFileDialogVisible"
                            ref="file_upload"
                            :ffileList="file_arr"
                            upload_url="currency/upload"
                            title="补充附件"
                        ></common-upload-component>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <div v-if="AddFileDialogVisible === false">
                        <el-button
                            v-if="add_file_auth"
                            type="success"
                            plain
                            @click="add_file()"
                            >补充附件</el-button
                        >
                        <el-button
                            v-if="to_approval_auth"
                            type="success"
                            plain
                            @click="to_approval('CurrencyEditForm')"
                            >提交</el-button
                        >
                        <el-button
                            v-if="sel_approval_auth"
                            type="warning"
                            plain
                            @click="sel_approval()"
                            >查看审批</el-button
                        >
                        <el-button
                            v-if="withdraw_auth"
                            type="danger"
                            plain
                            @click="currencyWithdraw('CurrencyEditForm')"
                            >审批撤回</el-button
                        >
                        <el-button
                            v-if="edit_auth"
                            type="primary"
                            plain
                            @click="$emit('show_edit')"
                            >修改</el-button
                        >
                        <el-button
                            v-if="del_auth"
                            type="danger"
                            plain
                            @click="currencyDel('CurrencyEditForm')"
                            >删除</el-button
                        >
                        <el-button
                            plain
                            @click="closeDialog('CurrencyEditForm')"
                            >关闭</el-button
                        >
                    </div>
                    <div v-else>
                        <el-button
                            type="success"
                            plain
                            @click="submit_add_file()"
                            >确定</el-button
                        >
                        <el-button
                            plain
                            @click="exit_add_file()"
                            >取消</el-button
                        >
                    </div>
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('CurrencyEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('CurrencyEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeDialog('CurrencyEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('CurrencyEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="closeDialog('CurrencyEditForm')"
                        >取消操作</el-button
                    >
                </div>
                <common-approval-dialog
                    :id="id"
                    :ApprovalDialogVisible="ApprovalDialogVisible"
                    :data="ApprovalData"
                    :current_examine_staff_id="currency.current_examine_staff_id"
                    :ApprovalAuth="ApprovalAuth"
                    :ApprovalRequest="CurrencyApprovalRequest"
                    @exitApprovalDialog="exitApprovalDialog"
                    @refresh="$emit('frefresh')"
                >
                </common-approval-dialog>
                <currency-print-component
                    :show_print="show_print"
                    :data="currency"
                    :ApprovalData="ApprovalData"
                    @exit_print="show_print = false"
                >
                </currency-print-component>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CommonUploadComponent from '@/components/common/CommonUploadComponent'
import CommonApprovalDialog from '@/components/common/CommonApprovalDialog'
import CurrencyPrintComponent from './CurrencyPrintComponent'

import {
    currency_add_request,
    currency_del_request,
    currency_edit_request,
    currency_to_approval_request,
    currency_sel_approval_request,
    currency_approval_request,
    currency_withdraw_request,
    currency_add_file_request
} from '@/network/finance/currency.js'
import { fomatFloat,thousandBitSeparator } from '@/assets/js/common.js'

export default {
    name: 'currencyEditComponent',
    data() {
        return {
            login_loading: false,
            ApprovalDialogVisible: false,
            currency: {
                department_id: [this.$store.state.user.enterprise_id,this.$store.state.user.department_id],
                staff_id: this.$store.state.user.id,
                category: '',
                title: '',
                cause: '',
                content: '',
                other: [],
                print: []
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: '请输入申请标题',
                        trigger: 'blur',
                    },
                ],
                cause: [
                    {
                        required: true,
                        message: '请填写申请原因',
                        trigger: 'blur',
                    },
                ],
                department_id: [
                    {
                        required: true,
                        message: '请选择申请部门',
                        trigger: 'blur',
                    },
                ],
                staff_id: [
                    {
                        required: true,
                        message: '请选择申请人',
                        trigger: 'blur',
                    },
                ],
                category: [
                    {
                        required: true,
                        message: '请选择申请类型',
                        trigger: 'blur',
                    },
                ],
            },
            ApprovalData: [],
            CurrencyApprovalRequest: currency_approval_request,
            show_print: false,
            AddFileDialogVisible: false,
            //补充附件
            file_arr: []
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return this.currency.name ? '印章使用申请：' + this.currency.name : '印章使用申请详情'
            } else if (this.show_type === 1) {
                return '添加印章使用申请'
            } else {
                return '修改印章使用申请'
            }
        },
    },
    methods: {
        closeDialog(formName) {
            this.currency = {
                department_id: [this.$store.state.user.enterprise_id,this.$store.state.user.department_id],
                staff_id: this.$store.state.user.id,
                category: '',
                title: '',
                cause: '',
                content: '',
                other: [],
                print: []
            }
            this.$emit('exitDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.currencyInsert(formName)
            })
        },
        currencyInsert(formName) {
            this.login_loading = true
            let d = this.currency
            d.department_id = d.department_id[d.department_id.length - 1]
            d.other = this.$refs.upload.fileList
            currency_add_request(d)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.currencyEdit(formName)
            })
        },
        currencyEdit(formName) {
            this.login_loading = true
            this.currency.id = this.id
            this.currency.department_id = this.currency.department_id[this.currency.department_id.length - 1]
            this.currency.other = this.$refs.upload.fileList
            currency_edit_request(this.currency)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.currency.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        currencyDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    currency_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeDialog(formName))
                })
                .catch((err) => {})
        },
        to_approval(formName) {
            this.$prompt('请填写申请原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.login_loading = true
                    currency_to_approval_request({id:this.id,note:value})
                        .then((s) => {
                            this.login_loading = false
                            if (s.status === 0) {
                                    this.$message.success('提交成功!')
                                    this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.login_loading = false
                            this.$message.error(err)
                        })
                        .finally(() => this.closeDialog(formName))
                }).catch(()=>{});
        },
        exitApprovalDialog() {
            this.ApprovalDialogVisible = false
        },
        sel_approval() {
            this.login_loading = true
            currency_sel_approval_request(this.id)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.ApprovalData = s.result
                        this.ApprovalDialogVisible = true
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        currencyWithdraw() {
            this.$confirm(
                '是否确定撤回？（请谨慎操作）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.login_loading = true
                    currency_withdraw_request({id:this.id})
                        .then((s) => {
                            this.login_loading = false
                            if (s.status === 0) {
                                this.$message.success('已撤回!')
                                this.$emit('frefresh')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.login_loading = false
                            this.$message.error(err)
                        })
                })
                .catch((err) => {})
        },
        clk_print() {
            this.login_loading = true
            currency_sel_approval_request(this.id)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.ApprovalData = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
            this.show_print = true
        },
        add_file() {
            this.AddFileDialogVisible = true
        },
        exit_add_file() {
            this.AddFileDialogVisible = false
            this.file_arr = []
        },
        submit_add_file() {
            let data = {}
            this.file_arr = this.$refs.file_upload.fileList
            data['id'] = this.id
            data['file'] = this.file_arr
            currency_add_file_request(data)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('补充附件成功!')
                        this.$emit('frefresh')
                        this.AddFileDialogVisible = false
                        this.file_arr = []
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        }
    },
    filters: {
        fomatFloatMoney(data) {
            return data ? thousandBitSeparator(fomatFloat(data)) + '元' : ''
        }
    },
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        currency_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        enterprise_department: {
            type: Array,
            default() {
                return []
            },
        },
        all_currency_category: {
            type: Array,
            default() {
                return []
            },
        },
        all_staff: {
            type: Array,
            default() {
                return []
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        edit_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        del_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        add_file_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        to_approval_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        sel_approval_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        ApprovalAuth: {
            type:Boolean,
            default() {
                return false
            }
        },
        withdraw_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        print_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        CommonUploadComponent,
        CommonApprovalDialog,
        CurrencyPrintComponent
    },
    watch: {
        currency_details_data(newVal) {
            this.currency = newVal
            this.currency.id = this.id
        },
    },
}
</script>

<style>
.input_number,.staff_idc,.categoryc {
    width: 100%;
}
</style>